import { Dispatch } from 'react';
import { OnRequestRuleFilters, OnRequestRuleRequest } from '../../../api/pricing/pricing.types';
import { PricingApi } from '../../../api/api.apiclient';
import {
  DeleteOnRequestRuleAction,
  DELETE_ON_REQUEST_RULE,
  GET_ON_REQUEST_RULE,
  GET_ON_REQUEST_RULE_LIST,
  POST_ON_REQUEST_RULE,
  PUT_ON_REQUEST_RULE,
  UpdateOnRequestRuleAction,
  UPDATE_ON_REQUEST_RULE_FILTERS
} from '../types/onrequestrule.types';
import { PageRequest } from '../../../api/api.types';

export const getOnRequestRuleList = (filters?: OnRequestRuleFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.OnRequestRules.listAllOnRequestRules(filters, page);

  dispatch({
    type: GET_ON_REQUEST_RULE_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getOnRequestRule = (id?: number) => async (dispatch: Dispatch<any>): Promise<any> => {
  if (id) {
    try {
      const response = await PricingApi.OnRequestRules.getOnRequestRule(id);

      dispatch({
        type: GET_ON_REQUEST_RULE,
        payload: {
          selectedOnRequestRule: response.data
        }
      });

      return Promise.resolve();
    } catch (e) {
      dispatch({
        type: GET_ON_REQUEST_RULE,
        payload: {
          selectedOnRequestRule: null
        }
      });

      return Promise.reject();
    }
  } else {
    dispatch({
      type: GET_ON_REQUEST_RULE,
      payload: {
        selectedOnRequestRule: null
      }
    });

    return Promise.resolve();
  }
};

export const editOnRequestRule = (id: number, request: OnRequestRuleRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.OnRequestRules.editOnRequestRule(id, request);

  dispatch({
    type: PUT_ON_REQUEST_RULE,
    payload: {
      selectedOnRequestRule: response.data
    }
  });
};

export const addNewONRequestRule = (request: OnRequestRuleRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.OnRequestRules.addNewOnRequestRule(request);

  dispatch({
    type: POST_ON_REQUEST_RULE,
    payload: {
      newOnRequestRule: response.data,
      success: true
    }
  });
};


export const deleteOnRequestRule = (id: number) => async (dispatch: Dispatch<DeleteOnRequestRuleAction>) => {
  await PricingApi.OnRequestRules.deleteOnRequestRule(id);
  dispatch({
    type: DELETE_ON_REQUEST_RULE,
    payload: {
      success: true
    }
  });
};

export const updateOnRequestRuleFilters = (filters: OnRequestRuleFilters) => async (dispatch: Dispatch<UpdateOnRequestRuleAction>) => {
  dispatch({
    type: UPDATE_ON_REQUEST_RULE_FILTERS,
    payload: {
      filters
    }
  });
};
